import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import './i18n';
import axios from 'axios';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

// Basic Auth Strategy
const BasicAuthStrategy = {
  getAuthHeader: () => {
    const u = process.env.REACT_APP_BASIC_USER || '';
    const p = process.env.REACT_APP_BASIC_PASS || '';
    if (!u || !p) return null;
    const token = btoa(`${u}:${p}`);
    return { Authorization: `Basic ${token}` };
  }
};

// Axios interceptor for Basic Auth
axios.interceptors.request.use((config) => {
  const hdr = BasicAuthStrategy.getAuthHeader();
  if (hdr) {
    config.headers = { ...config.headers, ...hdr };
  }
  return config;
}, (error) => Promise.reject(error));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <BrowserRouter>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}>
      <App/>
    </Auth0Provider>
 </BrowserRouter>
);
